import { AppGlueCorePlugins } from "./AppGlueCorePlugins";
import { LogLevel } from "./Plugins/Logging/LogLevel";

export function log(type: string, level: LogLevel, ...messages: string[]) {
    AppGlueCorePlugins.logger.log(type, level, ...messages);
}
